// Action Types
export const GET_NOTIFICATION_SETTINGS_REQUEST = 'GET_NOTIFICATION_SETTINGS_REQUEST';
export const GET_NOTIFICATION_SETTINGS_SUCCESS = 'GET_NOTIFICATION_SETTINGS_SUCCESS';
export const GET_NOTIFICATION_SETTINGS_FAIL = 'GET_NOTIFICATION_SETTINGS_FAIL';

export const CREATE_NOTIFICATION_SETTING_REQUEST = 'CREATE_NOTIFICATION_SETTING_REQUEST';
export const CREATE_NOTIFICATION_SETTING_SUCCESS = 'CREATE_NOTIFICATION_SETTING_SUCCESS';
export const CREATE_NOTIFICATION_SETTING_FAIL = 'CREATE_NOTIFICATION_SETTING_FAIL';

export const UPDATE_NOTIFICATION_SETTING_REQUEST = 'UPDATE_NOTIFICATION_SETTING_REQUEST';
export const UPDATE_NOTIFICATION_SETTING_SUCCESS = 'UPDATE_NOTIFICATION_SETTING_SUCCESS';
export const UPDATE_NOTIFICATION_SETTING_FAIL = 'UPDATE_NOTIFICATION_SETTING_FAIL';

export const DELETE_NOTIFICATION_SETTING_REQUEST = 'DELETE_NOTIFICATION_SETTING_REQUEST';
export const DELETE_NOTIFICATION_SETTING_SUCCESS = 'DELETE_NOTIFICATION_SETTING_SUCCESS';
export const DELETE_NOTIFICATION_SETTING_FAIL = 'DELETE_NOTIFICATION_SETTING_FAIL';

export const SET_NOTIFICATION_SETTINGS_LOADING = 'SET_NOTIFICATION_SETTINGS_LOADING';

// Action Creators
export const getNotificationSettingsRequest = () => ({
    type: GET_NOTIFICATION_SETTINGS_REQUEST
});

export const getNotificationSettingsSuccess = (settings) => ({
    type: GET_NOTIFICATION_SETTINGS_SUCCESS,
    payload: settings
});

export const getNotificationSettingsFail = (error) => ({
    type: GET_NOTIFICATION_SETTINGS_FAIL,
    error
});

export const createNotificationSettingRequest = (settingData) => ({
    type: CREATE_NOTIFICATION_SETTING_REQUEST,
    payload: settingData
});

export const createNotificationSettingSuccess = (setting) => ({
    type: CREATE_NOTIFICATION_SETTING_SUCCESS,
    payload: setting
});

export const createNotificationSettingFail = (error) => ({
    type: CREATE_NOTIFICATION_SETTING_FAIL,
    error
});

export const updateNotificationSettingRequest = (id, settingData) => ({
    type: UPDATE_NOTIFICATION_SETTING_REQUEST,
    payload: { id, settingData }
});

export const updateNotificationSettingSuccess = (setting) => ({
    type: UPDATE_NOTIFICATION_SETTING_SUCCESS,
    payload: setting
});

export const updateNotificationSettingFail = (error) => ({
    type: UPDATE_NOTIFICATION_SETTING_FAIL,
    error
});

export const deleteNotificationSettingRequest = (id) => ({
    type: DELETE_NOTIFICATION_SETTING_REQUEST,
    payload: { id }
});

export const deleteNotificationSettingSuccess = (id) => ({
    type: DELETE_NOTIFICATION_SETTING_SUCCESS,
    payload: { id }
});

export const deleteNotificationSettingFail = (error) => ({
    type: DELETE_NOTIFICATION_SETTING_FAIL,
    error
});

export const setNotificationSettingsLoading = (loading) => ({
    type: SET_NOTIFICATION_SETTINGS_LOADING,
    payload: loading
});
